/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseVoid } from '../models/api-response-void';
import { saveFcmToken } from '../fn/push-mobile-token-api/save-fcm-token';
import { SaveFcmToken$Params } from '../fn/push-mobile-token-api/save-fcm-token';

@Injectable({ providedIn: 'root' })
export class PushMobileTokenApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `saveFcmToken()` */
  static readonly SaveFcmTokenPath = '/v1/api/fcm/token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveFcmToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveFcmToken$Response(params: SaveFcmToken$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return saveFcmToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveFcmToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveFcmToken(params: SaveFcmToken$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.saveFcmToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

}
